














import Vue from 'vue';
import {Component,Prop, Watch} from 'vue-property-decorator';
import NumberPad from '@/components/money/numberPad.vue';
import Tabs from '@/components/Tabs.vue';
import FormItem from '@/components/money/FormItem.vue';
import Tags from '@/components/money/tags.vue';
import clone from '@/lib/clone';
import recordTypeList from '@/constants/recordTypeList'

@Component({
  components: {Tags, FormItem, Tabs, NumberPad},
})
export default class Money extends Vue{
  recordTypeList = recordTypeList; 
  get recordList(){
      return this.$store.state.recordList;
    }
  record: RecordItem={
    tags:[],notes:'',type:'-',amount:0
    };
  //刷新（更新）数据
 created() {
   this.$store.commit('fetchRecords');
 }
  onUpdateNotes(value:string){
    this.record.notes = value;
    
  }
  saverecord(){
    this.$store.commit('createRecord',this.record);
  }
}

